interface IconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  onClick?: () => void;
  title?: string;
}

export const PlayerIcon = ({ onClick, title, ...props }: IconProps) => (
  <button onClick={onClick}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" {...props} role="img" focusable="false">
      <title>{title}</title>
      <g fill="none" fillRule="evenodd">
        <circle cx={15} cy={15} r={15} fill="currentColor" />
        <path fill="#FFF" d="m11.9 10.128 8.39 4.786-8.487 4.957z" />
      </g>
    </svg>
  </button>
);

export const CloseIcon = ({ onClick, title, ...props }: IconProps) => (
  <button onClick={onClick}>
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} role="img" focusable="false">
      <title>{title}</title>
      <path d="M2.36842 2.36842L15.6316 15.6316" stroke="currentColor" strokeWidth="2" strokeLinecap="square" />
      <path d="M15.6316 2.36842L2.36842 15.6316" stroke="currentColor" strokeWidth="2" strokeLinecap="square" />
    </svg>
  </button>
);

export const ExitIcon = ({ width = 20, height = 20, color = '#fff', onClick, title, ...rest }: IconProps) => {
  const svgElement = (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      focusable="false"
    >
      <title>{title}</title>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.47 4.47a.75.75 0 011.06 0L10 8.94l4.47-4.47a.75.75 0 111.06 1.06L11.06 10l4.47 4.47a.75.75 0 11-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 01-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 010-1.06z"
        fill={color}
        stroke={color}
        strokeWidth="0"
      />
    </svg>
  );

  // Only wrap in button if onClick is provided (for standalone usage)
  // Otherwise, return just the SVG (for use inside other buttons)
  if (onClick) {
    return <button onClick={onClick}>{svgElement}</button>;
  }

  return svgElement;
};

export const PluseIcon = ({ onClick, title, ...props }: IconProps) => (
  <button onClick={onClick}>
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      role="img"
      focusable="false"
    >
      <title>{title}</title>
      <path d="M8.24 17.48V0.519999H10.76V17.48H8.24ZM0.8 10.2V7.84H18.2V10.2H0.8Z" fill="currentColor" />
    </svg>
  </button>
);

export const RightIcon = ({ onClick, title, ...props }: IconProps) => (
  <button onClick={onClick}>
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      role="img"
      focusable="false"
    >
      <title>{title}</title>
      <path d="M1 5.16L4.75 9L11 1" stroke="currentColor" stroke-width="2" />
    </svg>
  </button>
);

export const ChevronDownIcon = ({ className = '', ...props }: { className?: string; [key: string]: any }) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M1 1L5 5L9 1" stroke="#1e3a8a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
